exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput.timer-input[data-v-fc48a936] {\n  width: 100%;\n  text-align: center;\n  border: none;\n  padding-left: 1%;\n  padding-right: 1%;\n  height: 2.2em;\n  border-bottom: 1px solid #0b6d3b85;\n}\n.dark input[data-v-fc48a936] {\n  background-color: #194249;\n  color: wheat;\n}\n.dark input[data-v-fc48a936]:focus {\n  background-color: #194249;\n  color: wheat;\n}\n", ""]);

// exports
